import HeaderNoteInfo from "./HeaderNoteInfo";
export default HeaderNoteInfo;
